(function ($) {
  $(function () {
    function updateSideSpacing() {
      const windowWidth = $(window).width();
      const contentWidth = $(
        '.page-template-wp-custom-template-medlemssida main > .wp-block-columns'
      ).width();
      const sideSpacing = (windowWidth - contentWidth) / 2;
      document.documentElement.style.setProperty('--side-spacing', sideSpacing + 'px');
    }
    updateSideSpacing();
    $(window).on('resize', function () {
      updateSideSpacing();
    });

    $('.navigation-btn').on('click', function () {
      $(this).toggleClass('open');
      $('.navigation-content').toggleClass('open');
    });
  });
})(jQuery);
